var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{class:_vm.fit === 'height' ? 'logo-fit-height' : 'logo-fit-width',attrs:{"src":_vm.src,"alt":"Logos"}})])}
var staticRenderFns = []

export { render, staticRenderFns }